/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum AccountStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
  NOT_INVITED = 'NOT_INVITED',
}

export enum EnrollmentStatus {
  NOT_INVITED = 'NOT_INVITED',
  INVITED = 'INVITED',
  COMPLETED = 'COMPLETED',
}

export enum QuestionType {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  DIFFERENTIAL = 'DIFFERENTIAL',
}

export enum Seniority {
  JUNIOR = 'JUNIOR',
  MID = 'MID',
  SENIOR = 'SENIOR',
}
